import { render, staticRenderFns } from "./SidebarExpandMenuItem.vue?vue&type=template&id=622a14ef&"
import script from "./SidebarExpandMenuItem.vue?vue&type=script&lang=js&"
export * from "./SidebarExpandMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports